module.exports = __webpack_public_path__ + "static/media/src2.00ee3f34.jpg";